<template>
  <div>
    <v-container class="pa-0" fluid>
      <!-- Toolbar -->
      <v-row class="mx-0" style="height: 48px; max-height: 48px">
        <ContenidoBase
          :EstadoBtn="EstadoBtn"
          :descripcion="'Las existencias en esta pantalla estan representadas en la unidad base es decir la unidad miníma del producto.'"
          :show-absolute="false"
          :titulo="'Existencia de productos'"
          @MethodAnular="anular"
          @MethodEliminar="remove"
          @MethodGuardar="save"
          @MethodImprimir="imprimirList"
          @MethodNuevo="newwnuevo"
          @abrirBarraTablaDinamica="abrirTabla"
        />
      </v-row>
      <!-- fn Toolbar  -->

      <v-row class="mx-0">
        <!-- Contenido central --->
        <v-col class="ma-1">

          <div class="px-2">
            <v-card color="grey lighten-3">

              <div class="px-2">
                <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="">

                  <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
                    <v-row class="pa-0 ma-0 py-0 my-0">
                      <v-col class="pa-0 ma-0 px-2 pb-2 " cols="12" md="12" sm="12">
                        <h4>Consultas de productos</h4>
                      </v-col>
                      <v-col class="pa-0 ma-0 px-2 pb-2 " cols="12" md="6" sm="6">
                        <v-combobox
                          ref="productoCombo"
                          v-model="ExitenciaProductos.producto"
                          :items="Rproducto"
                          autocomplete="off"
                          dense
                          hide-details
                          item-text="codProDesc"
                          label="Productos:"
                          no-filter
                          outlined
                          @blur="SelctCbProduc"
                          @change="changeProducto"
                          @focus="CargarRproducto"
                          @keyup="CbFilProducto"
                          v-on:change="BuscarFiltros"
                        >
                          <template slot="item" slot-scope="item">
                        <span style="display:none;">{{ item.item.codProDesc = `${item.item.productos.codigo} - ${item.item.productos.descripcion.trim()} ${item.item.unidades.descripcion.trim()} `
                                }}</span>
                            <span  class="fontSize13"><b>{{ item.item.productos.codigo }}</b> - {{ item.item.productos.descripcion.trim()  }} <b>{{ item.item.unidades.descripcion.trim() }}</b> </span>
                          </template>

                          <template v-slot:selection="{ attrs, item, parent, selected }">
                              <span v-if="item.hasOwnProperty('productos')"
                                    class="fontSize13 colorNombre"> <b>{{
                                  item.productos.codigo
                                }}</b> - {{ item.productos.descripcion }} {{ item.unidades.descripcion }}  </span>
                          </template>
                          <template v-slot:prepend>
                            <i
                              class="fa fa-shopping-cart"
                              style="font-size: 20px;"
                              @click="productoClick"
                            ></i>
                          </template>
                        </v-combobox>
                      </v-col>

                      <v-col class="pa-0 ma-0 px-2 pb-2" cols="12" md="6" sm="6">
                        <v-combobox
                          v-model="ExitenciaProductos.proveedor"
                          :items="Rproveedor"
                          autocomplete="off"
                          dense
                          hide-details
                          item-text="nombre"
                          label="proveedor:"
                          outlined
                          style="font-size: 13px;"
                          @blur="SelctCbProveedor"
                          @change="BuscarFiltros"
                          @focus="cargarProveedor"
                          @keyup="CbFilProveedor"

                        >
                          <template v-slot:prepend>
                            <i class="fa fa-user-circle" style="font-size: 20px;"></i>
                          </template>
                        </v-combobox>
                      </v-col>

                      <v-col class="pa-0 ma-0 px-2" cols="12" md="4" sm="4">
                        <!-- -----------------------------  almacen  -->
                        <v-combobox
                          v-model="ExitenciaProductos.almacen"
                          :items="Ralmacen"
                          autocomplete="off"
                          dense
                          hide-details
                          item-text="descripcion"
                          label="Almacén"
                          outlined
                          required
                          @blur="SelctCbAlmacen"
                          @change="BuscarFiltros"
                          @focus="CargarRalmacen"
                        >
                          <template v-slot:prepend>
                            <v-img
                              height="20px"
                              src="../assets/warehouse.png"
                              width="20px"
                            ></v-img>
                          </template>
                        </v-combobox>
                      </v-col>

                      <v-col class="pa-0 ma-0 px-2" cols="12" md="4" sm="4">
                        <v-combobox
                          v-model="ExitenciaProductos.departamento"
                          :items="RDepartamento"
                          :rules="[$rules.required]"
                          autocomplete="off"
                          dense
                          hide-details
                          item-text="descripcion"
                          label="Departamento:"
                          outlined
                          @blur="SelctCbDesc"
                          @change="BuscarFiltros"
                          @focus="cargarDepartamento"
                        >
                          <template v-slot:prepend>
                            <i
                              class="fa fa-building"
                              style="font-size: 20px;"
                            ></i>
                          </template>
                        </v-combobox>
                      </v-col>

                      <v-col class="pa-0 ma-0 px-2" cols="12" md="4" sm="4">
                        <v-combobox
                          v-model="ExitenciaProductos.fabricante"
                          :items="RFabricante"
                          :rules="[$rules.required]"
                          autocomplete="off"
                          dense
                          hide-details
                          item-text="nombre"
                          label="Fabricante:"
                          outlined
                          @blur="SelctCbFabricantes"
                          @change="BuscarFiltros"
                          @focus="CargarRFabricantes"
                        >
                          <template v-slot:prepend>
                            <i
                              class="fa fa-wrench"
                              style="font-size: 20px;"
                            ></i>
                          </template>
                        </v-combobox>
                      </v-col>

                      <v-col class="pa-0 ma-0 px-2" cols="12" md="4" sm="4">
                        <v-switch v-model="ExitenciaProductos.ordenAscDesc" class="mt-0" color="teal" hide-details
                                  label=""
                                  @change="BuscarFiltros">
                          <template v-slot:label>
                            <strong v-if="ExitenciaProductos.ordenAscDesc == true"
                                    style="color:#000000; font-size:13px;">Ordenar: Ascendente.</strong>
                            <strong v-if="ExitenciaProductos.ordenAscDesc == false"
                                    style="color:#000000; font-size:13px;">Ordenar: Descendente.</strong>
                          </template>
                          <template v-slot:prepend>
                            <i v-if="ExitenciaProductos.ordenAscDesc == true" class="fa fa-sort-alpha-asc"
                               style="font-size: 20px;"></i>
                            <i v-if="ExitenciaProductos.ordenAscDesc == false" class="fa fa-sort-alpha-desc"
                               style="font-size: 20px;"></i>

                          </template>
                        </v-switch>
                      </v-col>

                    </v-row>
                  </v-col>
                  <v-row>

                    <!-- fn columna 1 -->
                    <v-col class="pa-0 ma-0 py-0 my-0 pt-2" cols="12" md="12" sm="12">
                      <div style="border: 1px solid #000000;">
                        <v-data-table
                          ref="dataTable"
                          :footer-props="$arrayPropiedasesGlobal"
                          :headers="[
                { text: 'Nombre', sortable: true,  value: 'productos.descripcion', width:'auto', class: ['no-gutters black--text']  },
                 { text: 'Und', sortable: false, value: 'unidad.descripcion', width:'auto', class: ['no-gutters black--text']  },
                 { text: 'Fabricante', sortable: false, value: 'productos.fabricante.nombre', width:'auto', class: ['no-gutters black--text']  },
                 { text: '$ Costo', sortable: false, value: 'unidadproducto.costo', width:'auto', class: ['no-gutters black--text']  },
                 { text: '$ Precio', sortable: false, value: 'unidadproducto.precio', width:'auto', class: ['no-gutters black--text']  },
                 { text: 'Exixtencia', sortable: false, value: 'balance', width:'auto', class: ['no-gutters black--text']  },
                 { text: '$ Valor', sortable: false, value: 'valor', width:'auto', class: ['no-gutters black--text']  },
                 { text: 'Almacén', sortable: false, value: 'almacenes.descripcion', width:'auto' , class: ['no-gutters black--text'] },
                 ]"
                          :items="listDatos"
                          :items-per-page="TbPaginator.itemsPerPage"
                          :page="TbPaginator.page"
                          :pageCount="TbPaginator.pageCount"
                          :search="search"
                          :server-items-length="TbTotalItem"
                          class="elevation-1  TbSize13"
                          dense
                          @pagination="cargarPaginacionAll"
                        >

                          <template #item="{ item, index }">
                            <tr :class="getRowClass(item, index)">
                              <td>{{ item.productos.descripcion }}</td>
                              <td>{{ item.unidad.descripcion }}</td>
                              <td>{{ item.productos.fabricante.nombre }}</td>
                              <td>
                                <span>{{ currencyFormatter(item.unidadproducto.costo) }}</span>
                              </td>
                              <td>
                                <span>{{ currencyFormatter(item.unidadproducto.precio) }}</span>
                              </td>
                              <td>{{ item.balance }}</td>
                              <td>
                                <span>{{ currencyFormatter(item.valor) }}</span>
                              </td>
                              <td>{{ item.almacenes.descripcion }}</td>
                            </tr>
                          </template>

                          <template #body.append>
                            <tr>
                              <td class="border-top-bottom"><strong></strong></td>
                              <td class="border-top-bottom"><strong></strong></td>
                              <td class="border-top-bottom"><strong class="d-flex justify-end"
                                                                    style="font-size:15px; color: #00838F;">Total:</strong>
                              </td>
                              <td class="border-total"><strong class="d-flex justify-center"
                                                               style="font-size:15px; color: #00838F;">
                                {{ currencyFormatter(totales.costo) }} </strong></td>
                              <td class="border-total"><strong class="d-flex justify-center"
                                                               style="font-size:15px; color: #00838F;">
                                {{ currencyFormatter(totales.precio) }} </strong></td>
                              <td class="border-total"><strong class="d-flex justify-center"
                                                               style="font-size:15px; color: #00838F;">
                                {{ currencyFormatter(totales.existencia) }} </strong></td>
                              <td class="border-total"><strong class="d-flex justify-center"
                                                               style="font-size:15px; color: #00838F;">
                                {{ currencyFormatter(totales.valor) }} </strong></td>

                              <td class="border-top-bottom"><strong></strong></td>

                            </tr>
                          </template>

                          <template v-if="windowSize.width<=600" v-slot:footer>
                            <v-list-item class="white--text" style="font-size: 70%;">
                              <v-list-item-content>
                                <span>Total costo: {{ currencyFormatter(totales.costo) }}</span>
                                <span>Total precio: {{ currencyFormatter(totales.precio) }}</span>
                                <span>Total existencia: {{ currencyFormatter(totales.existencia) }}</span>
                                <span>Valor valor: {{ currencyFormatter(totales.valor) }}</span>
                              </v-list-item-content>
                            </v-list-item>

                          </template>

                        </v-data-table>

                      </div>
                    </v-col>

                  </v-row>

                </v-form>
              </div>

            </v-card>
          </div>
        </v-col>
        <!-- fn contenido central ------------------------------------------------------------------------------------->
      </v-row>
    </v-container>
    <!-- Modales -------------------------------------------------------------------------------------------------->
    <!-- ------------------------------------------------------ tb-data-->
    <v-dialog
      v-model="acti_tb_data"
      label="myAlert"
      max-height="100%"
      max-width="100%"
      persistent
      transition="fab-transition"
    >
      <v-card>
        <v-toolbar color="#BDBDBD" flat>
          <i class="fa fa-file-pdf-o" style="font-size: 20px;"></i>
          <v-toolbar-title class="font-weight-light"> REPORTE</v-toolbar-title>
          <i class="fa fa-file-pdf-o" style="font-size: 20px;"> </i>

          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            fab
            small
            @click="acti_tb_data = !acti_tb_data"
          >
            <i class="fa fa-close" style="font-size: 20px; color:#dd4b39;"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field
                v-model="search"
                hide-details
                label="Buscar"
                single-line
                @keyup="filtro"
              >
                <template v-slot:prepend-inner>
                  <i class="fa fa-search" style="font-size: 35px;"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table
              :headers="slotHtabla"
              :items="list"
              :search="search"
              dense
              @click:row="datostabla"
            >
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Elim_notif-->
    <v-dialog
      v-model="Elim_notif.estado"
      label="myAlert"
      max-width="350"
      persistent
      transition="fab-transition"
    >
      <template v-slot:activator="{ on }" justify="center"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i class="fa fa-warning" style="font-size: 28px;"></i>
            CONFIRMACION
            <i class="fa fa-warning" style="font-size: 28px;"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ Elim_notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn
            small
            @click.prevent="
              eliminar(), (Elim_notif.estado = !Elim_notif.estado)
            "
          >
            <i class="fa fa-check" style="font-size: 20px;"></i> Si
          </v-btn>

          <v-btn small @click.prevent="Elim_notif.estado = !Elim_notif.estado">
            <i class="fa fa-ban" style="font-size: 20px;"></i> No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Elim_notif -->

    <!------------otras funciones---------------->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      :timeout="120000"
      :vertical="true"
      style="margin-top: 20%;"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <!-- fn Modales ----------------------------------------------------------------------------------------------->


  </div>
</template>


<script>
import { currencyFormatter, FormatoFecha, HoraFormatter } from "@/js/Funciones.js"
import { EventBus } from "../event-bus"
import BarraBusqueda2 from "../components/BarraBusquedaDinam"
import ContenidoBase from "../components/ContenidoBase"

export default {
  components: {
    BarraBusqueda2,
    ContenidoBase,

  },

  created() {
    var json = {
      titulo: "Existencia de productos",
      descripcion: "Las existencias en esta pantalla estan representadas en la unidad base es decir la unidad miníma del producto.",
      save: false,
      eliminar: false,
      anular: false,
      nuevo: false,
      imprimir: false,
      btnBarraDi: false,

      accion: [
        "ExitenciaProductosNew",
        "ExitenciaProductosSave",
        "ExitenciaProductosRemove",
        "ExitenciaProductosAnular",
        "ExitenciaProductosPrintList",
      ],
    }
    EventBus.$emit("anularBotonesAccion", json)
  },
  mounted() {
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla)
    // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    // EventBus.$on("ExitenciaProductosNew", this.new);
    // EventBus.$on("ExitenciaProductosSave", this.save);
    // EventBus.$on("ExitenciaProductosRemove", this.remove);
    // EventBus.$on("ExitenciaProductosAnular", this.remove);
    // EventBus.$on("ExitenciaProductosPrintList", this.imprimirList);
    EventBus.$on("emitExitenciaProductos", this.datostabla)
    EventBus.$on("onResize", this.onResize)
    document.addEventListener("keyup", this.navegarTabla)
  },

  data: () => ({


    Ralmacen: [],
    RDepartamento: [],
    RFabricante: [],
    Rproveedor: [],
    Rproducto: [],
    listDatos: [],
    ListaTiposClientes: [],
    windowSize: { width: "auto", height: "auto" },
    ExitenciaProductos: {
      proveedor: null,
      producto: null,
      almacen: null,
      departamento: null,
      fabricante: null,
      ordenAscDesc: true,
      // fechaCreacion: new,
      //  fechaModificacion: "",
    },

    totales: {
      costo: 0,
      precio: 0,
      existencia: 0,
      valor: 0,
    },

    TbTotalItem: 0,
    TbPaginator: {
      page: 1,
      itemsPerPage: 5,
      pageStart: 1,
      pageStop: 15,
      pageCount: 10,
      itemsLength: 5,
    },


    EstadoBtn: {
      BarraTablaDinamicaAprir: false,
      nuevo: true,
      guardar: false,
      eliminar: false,
      anular: false,
      imprimir: false,
      vercuenta: false,
      guardartemporal: false,
      restaurartemporal: false,
      importarDato: false,
      cargarProducto: false,
      ImprimirproductoInv: false,
    },


    text: "",
    valid: true,
    BarraTablaDinamicaAprir: false,
    BarraSecundariaAprir: false,

    navegacionDataTable: -1,

    headers: [{ text: "Tipo Clientes", value: "descripcion" }],

    slotHtabla: [
      { text: "Código", value: "codigo" },
      { text: "Descripcion", value: "descripcion" },
    ],

    list: [],
    search: "",
    acti_tb_data: false,
    Elim_notif: {
      estado: false,
      nombre: "¿Seguro que desea anular este registro?",
    },

    aalert: {
      estado: false,
      color: null,
    },

  }),

  methods: {
    currencyFormatter, FormatoFecha, HoraFormatter,

    onResize(e) {
      this.windowSize = e
    },

    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir
    },

    datostabla(e) {
      this.ExitenciaProductos = e
      this.acti_tb_data = false
    },
    save() {
    },
    remove() {
    },
    eliminar() {
    },
    anular() {
    },
    imprimirList() {
    },
    newwnuevo() {
      this.ExitenciaProductos = {
        proveedor: null,
        producto: null,
        almacen: null,
        departamento: null,
        fabricante: null,
        // fechaCreacion: new,
        //  fechaModificacion: "", 
      }

      this.totales = {
        costo: 0,
        precio: 0,
        existencia: 0,
        valor: 0,
      }

      this.navegacionDataTable = -1
      this.BuscarFiltros()
    },

    CargarRproducto() {
      this.$axios.get(this.$hostname + this.$hName +
        "/unidades-productos/*/false/buscar",
        { headers: this.$store.getters.GetheadersAxios },
      ).then(res => {
        this.Rproducto = res.data
      })
    },

     changeProducto(e){
if(typeof e === "string"){
 var _this = this;
      setTimeout(function () {
      _this.$axios.get( _this.$hostname +_this.$hName +
            "/unidades-productos/" +
            (e.trim() === "" ? "A" : e.trim().replaceAll("/", "*-S-*")) +
            "/false/buscar/true",
            { headers: _this.$store.getters.GetheadersAxios },
          )
          .then((res) => (_this.Rproducto = res.data))

      }, 300)
}

    },
    CbFilProducto(e) {
      if (e.keyCode!= 13 && e.target.value.trim().length > 0) {
        this.$axios
          .get(this.$hostname +
            this.$hName +
            "/unidades-productos/" + (e.target.value === "" ? "A" : e.target.value.trim().replaceAll("/", "*-S-*")) + "/false/buscar",
            { headers: this.$store.getters.GetheadersAxios },
          )
          .then(res => {
            this.Rproducto = res.data
          })
      }

    },



    SelctCbProduc() {
      if (this.ExitenciaProductos.producto == null) {
        this.ExitenciaProductos.producto = ""
      }

      if (this.ExitenciaProductos.producto.productos == undefined) {
        this.alerta("Seleccione un producto", "error")
        this.ExitenciaProductos.producto = ""
        return
      }
    },

    CargarRalmacen() {
      this.$axios
        .get(this.$hostname + this.$hName + "/almacen/activos",
          { headers: this.$store.getters.GetheadersAxios },
        )
        .then(res => {
          this.Ralmacen = res.data
        })
    },

    SelctCbAlmacen() {
      if (this.ExitenciaProductos.almacen == null) {
        this.ExitenciaProductos.almacen = ""
      }

      if (this.ExitenciaProductos.almacen.codigo == undefined) {
        this.alerta("Seleccione un Almacén", "error")
        this.ExitenciaProductos.almacen = ""
        return
      }
    },

    CargarRFabricantes() {
      this.$axios
        .get(
          this.$hostname + this.$hName + "/fabricante/activo",
          {
            headers: this.$store.getters.GetheadersAxios,
          },
        ).then(res => this.RFabricante = res.data)
        .catch()
    },

    SelctCbFabricantes() {
      if (this.ExitenciaProductos.fabricante == null) {
        this.ExitenciaProductos.fabricante = ""
      }

      if (this.ExitenciaProductos.fabricante.codigo == undefined) {
        this.alerta("Seleccione un fabricante", "error")
        this.ExitenciaProductos.fabricante = ""
        return
      }
    },

    cargarDepartamento() {
      this.$axios
        .get(
          this.$hostname + this.$hName + "/departamento/activo",
          {
            headers: this.$store.getters.GetheadersAxios,
          },
        ).then(res => this.RDepartamento = res.data)
        .catch(error => {
          if (error.response) {
            this.alerta(error.response.request.responseText, "error")
          } else {
            this.alerta(error, "error")
          }
        })
    },

    SelctCbDesc() {
      if (this.ExitenciaProductos.departamento == null) {
        this.ExitenciaProductos.departamento = ""
      }

      if (this.ExitenciaProductos.departamento.codigo == undefined) {
        this.alerta("Seleccione un departamento", "error")
        this.ExitenciaProductos.departamento = ""
        return
      }
    },

    cargarProveedor() {
      this.$axios.get(this.$hostname + this.$hName + "/proveedores/findallbyDesc/25/0/*", { headers: this.$store.getters.GetheadersAxios })
        .then(res => (this.Rproveedor = res.data))
    },

    CbFilProveedor(e) {
      if (e.target.value.length >= 0) {
        this.$axios
          .get(
            this.$hostname +
            this.$hName +
            "/proveedores/findallbyDesc/25/0/" + (e.target.value === "" ? "*" : e.target.value),
            { headers: this.$store.getters.GetheadersAxios },
          )
          .then(res => (this.Rproveedor = res.data))
      }
    },

    SelctCbProveedor() {
      if (this.ExitenciaProductos.proveedor == null) {
        this.ExitenciaProductos.proveedor = ""
      }

      if (this.ExitenciaProductos.proveedor.codigo == undefined) {
        this.alerta("Seleccione un proveedor", "error")
        this.ExitenciaProductos.proveedor = ""

        return
      }

    },

    BuscarFiltros() {
      var Pg = {
        itemsLength: this.TbPaginator.itemsLength,
        itemsPerPage: this.TbPaginator.itemsPerPage,
        page: 1,
        pageCount: 1,
        pageStart: 0,
        pageStop: this.TbPaginator.itemsPerPage,
      }

      this.TbPaginator = JSON.parse(JSON.stringify(Pg))
      this.BuscarExistenciproducto()
    },

    cargarPaginacionAll(e) {
      if (e.itemsPerPage == -1) {
        e.itemsPerPage = 15
      }
      this.TbPaginator = JSON.parse(JSON.stringify(e))
      this.BuscarExistenciproducto()
    },


    BuscarExistenciproducto() {


      var _this = this
      setTimeout(function() {
        var sma = _this.$store.getters.GetheadersAxios["X-TENANT-ID"]
        var where = ` where bl.borrado= false`
        if (_this.ExitenciaProductos.proveedor != null && _this.ExitenciaProductos.proveedor.hasOwnProperty("codigo")) {
          where += ` and bl.producto in (select producto from ${sma}.producto_suplidor ps where ps.proveedor = ${_this.ExitenciaProductos.proveedor.codigo} )`
        }
        if (_this.ExitenciaProductos.almacen != null && _this.ExitenciaProductos.almacen.hasOwnProperty("codigo")) {
          where += ` and al.codigo= ${_this.ExitenciaProductos.almacen.codigo}`
        }
        if (_this.ExitenciaProductos.departamento != null && _this.ExitenciaProductos.departamento.hasOwnProperty("codigo")) {
          where += ` and pr.departamento= ${_this.ExitenciaProductos.departamento.codigo}`
        }
        if (_this.ExitenciaProductos.fabricante != null && _this.ExitenciaProductos.fabricante.hasOwnProperty("codigo")) {
          where += ` and pr.fabricante= ${_this.ExitenciaProductos.fabricante.codigo}`
        }
        if (_this.ExitenciaProductos.producto != null && _this.ExitenciaProductos.producto.hasOwnProperty("unidadesProductosPK")) {
          where += ` and bl.producto= ${_this.ExitenciaProductos.producto.unidadesProductosPK.producto}`
        }

        var q = `select &
                 from ${sma}.balanceinventario bl
                        INNER JOIN ${sma}.productos pr on bl.producto = pr.codigo
                        INNER JOIN ${sma}.unidades un on bl.unidad = un.codigo
                        INNER JOIN ${sma}.almacenes al on bl.almacen = al.codigo ${where} `

        if (_this.ExitenciaProductos.ordenAscDesc == true) {
          q += " ORDER BY pr.descripcion asc "
        } else {
          q += " ORDER BY pr.descripcion desc "
        }

// var q=`select & from ${sma}.almacenes al, ${sma}.unidades_productos up INNER JOIN ${sma}.productos pr on up.producto=pr.codigo left JOIN 
// ${sma}.producto_suplidor ps on ps.producto=up.producto ${where} order by pr.codigo`

        var obj = {
          limit: _this.TbPaginator.itemsPerPage,
          ultimo: _this.TbPaginator.pageStart,
          qry: q,
        }


        var link = ``
        _this.$axios
          .post(_this.$hostname + _this.$hName + "/ConsultaRapida/ExistenciaProductos", obj, { headers: _this.$store.getters.GetheadersAxios })
          .then(res => {
            _this.TbTotalItem = res.data.TbTotalItem
            _this.calcularTotal(res.data.list)
          })
          .catch(error => {
            _this.alerta("Nodata(" + error + ")", "error")
          })

      }, 300)

      this.navegacionDataTable = this.navegacionDataTable >= 0 ? 0 : -1
    },


    async calcularTotal(e) {
      this.totales = {
        costo: 0,
        precio: 0,
        existencia: 0,
        valor: 0,
      }

      var obj = JSON.parse(JSON.stringify(e))

      await obj.forEach(elent => {

        elent.valor = elent.unidadproducto.costo * elent.balance
        this.totales.costo += elent.unidadproducto.costo
        this.totales.precio += elent.unidadproducto.precio
        this.totales.existencia += elent.balance
        this.totales.valor += elent.valor
      })

      this.listDatos = obj
    },

    productoClick() {
    },

    alerta(e, l) {
      if (l == "bien") {
        this.aalert.estado = true
        this.aalert.color = "success"
        this.aalert.nombre = e

        this.newwnuevo()
      }

      if (l == "error") {
        this.aalert.estado = true
        this.aalert.color = "error"
        this.aalert.nombre = e

        this.ejecucion = false
      }
    },

    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data
      this.filtro()
    },

    async filtro() {
      await this.$axios
        .post(this.$hostname + this.$hName + "/services/tipocliente/findalltipoclientes", {
          usuario: JSON.parse(JSON.stringify(this.$user)),
        })
        .then(res => {
          this.list = res.data
        })
    },

    navegarTabla(event) {
      if (document.activeElement.tagName !== "BODY") return

      if (event.code === "ArrowUp") {
        this.navegacionDataTable--
      } else if (event.code === "ArrowDown") {
        this.navegacionDataTable++
      }
    },

    getRowClass(item, index) {
      return index === this.navegacionDataTable ? "selected-row" : ""
    },
  },

  computed: {
    ActDescBtn() {
      this.windowSize = JSON.parse(JSON.stringify(this.$store.getters.GetwindowSize))
    },
  },

  watch: {
    navegacionDataTable(val) {
      if (this.disableNavegacionWatcher) return
      if (val > this.listDatos.length - 1) {
        this.navegacionDataTable = 0
      } else if (val < -1) {
        this.navegacionDataTable = this.listDatos.length - 1
      }
    },
  },
}
</script>

<style>
.selected-row {
  background: #f89c9c !important;
}
</style>
